import { srtCells } from './srt';
import type { SrtLink } from './types';

/**
 * The SRT block of the input (docs/srt-ingest.md §3): RTT, latency, loss,
 * resends and late packets over the last 5 s, the cipher. Neutral on purpose:
 * resending lost packets is how SRT works on a lossy path, and a problem of the
 * input is only what state_reason / health say (measure 4), shown elsewhere.
 */
export function SrtLinkPanel({ link, compact }: { link: SrtLink; compact?: boolean }) {
  const cells = srtCells(link);
  return (
    <section data-testid="input-srt" aria-label="SRT connection, last 5 seconds"
      className={`flex flex-col gap-2 ${compact ? 'border-t border-line pt-2.5' : 'rounded-md border border-line px-3 py-2.5'}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="font-mono text-[10px] font-medium tracking-[.12em] text-muted">SRT CONNECTION</span>
        <span className="text-[11px] text-muted">last 5 s · resends are normal on a lossy path</span>
      </div>
      <dl className={`m-0 grid gap-x-4 gap-y-1.5 ${compact ? 'grid-cols-2' : 'grid-cols-4 lg:grid-cols-8'}`}>
        {cells.map((c) => (
          <div key={c.id} title={c.hint} data-testid={`input-srt-${c.id}`} className="min-w-0">
            <dt className="text-[11px] text-muted">{c.label}</dt>
            <dd className="m-0 truncate font-mono text-[13px] text-text-soft tabular-nums">{c.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
